<div class="img__edit--modal">
  <button type="button" class="btn btn-link" aria-label="Close" (click)="dismiss()">
    <span class="icon icon-close"></span>
  </button>
  <div class="modal-body">
    <div class="addSummary">
      <div class="container">
        <div class="row pricing-header justify-content-md-center">
          <div class="col-md-12 text-center">
            <h4 *ngIf="data.referer=='dashboard'">Upgrade your account to use the PRO features</h4>
            <div [hidden]="data.referer=='dashboard'">
              <div *ngIf="data.referer=='theme'">
                <h4>You've used Pro Features</h4>
                <span class="small text-success" [hidden]="theme_id==1 || theme_id==2 || theme_id==3"><span class="icon icon-check"></span> Pro Theme Format</span>
                <span class="small text-success" [hidden]="data.theme_class=='theme__black'"><span class="icon icon-check"></span> Pro Color</span>
                <span class="small text-success" [hidden]="data.font_class=='font__Times'"><span class="icon icon-check"></span> Pro Font</span>
                <span class="small text-success" [hidden]="data.show_border==false"><span class="icon icon-check"></span> Resume Border</span>
                <!-- <p class="small text-success" *ngIf="data.theme_class!='theme__black' || data.font_class!='font__Times' || data.show_border!=false">Removing the above PRO features will enable you to download your Resume for free!</p> -->
              </div>
            </div>
          </div>
          <div class="col-md-12 text-center">
              <p>Get access to pro features that help you make eye catching resume at a price lesser than a 🍕pizza</p>
            </div>
          <div class="col-md-3 text-center">
            <select class="btn-outline-pro btn-font" [(ngModel)]="currency">
              <option value="USD">USD</option>
              <option value="INR">INR</option>
            </select>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-12">
            <button (click)="myPay()">My Pay</button>
          </div>
        </div> -->
        <div class="row justify-content-md-center pricing-table">
          <div class="col-md-4">
            <div class="item">
              <div class="heading">
                <div class="price">
                  <h4 *ngIf="currency=='USD'">$2.95</h4>
                  <h4 *ngIf="currency=='INR'">₹ 179</h4>
                  <h5>1 Month Plan</h5>
                </div>
              </div>
              <ul class="list-unstyled text-center">
                <li>Valid for 1 month</li>
                <li>Unlimited resume</li>
                <li>Unlimited Cover letter</li>
                <li>Font customisation</li>
                <li>Border and color option</li>
              </ul>
              <div class="">
                <button class="btn btn-block btn-default" *ngIf="currency=='USD'" (click)="startPayment(currency, '295')">Get Pro Monthly</button>
                <button class="btn btn-block btn-default" *ngIf="currency=='INR'" (click)="startPayment(currency, '17900')">Get Pro Monthly</button>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="item">
              <div class="ribbon">Most Popular</div>
              <div class="heading">
                <div class="price">
                  <h4 *ngIf="currency=='USD'">$2<sup>/m</sup></h4>
                  <h4 *ngIf="currency=='INR'">₹ 112<sup>.25/m</sup></h4>
                  <h5>4 Months Plan</h5>
                </div>
              </div>
              <ul class="list-unstyled text-center">
                <li *ngIf="currency=='USD'"><s class="strike">$11.8</s> $8 valid for 4 months</li>
                <li *ngIf="currency=='INR'"><s class="strike">₹ 716</s> ₹ 449 valid for 4 months</li>
                <li>Unlimited resume</li>
                <li>Unlimited Cover letter</li>
                <li>Font customisation</li>
                <li>Border and color option</li>
              </ul>
              <div class="">
                <button class="btn btn-block btn-primary" *ngIf="currency=='USD'" (click)="startPayment(currency, '800')">Get and Save 32%</button>
                <button class="btn btn-block btn-primary" *ngIf="currency=='INR'" (click)="startPayment(currency, '44900')">Get and Save 32%</button>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="item">
              <div class="heading">
                <div class="price">
                  <h4 *ngIf="currency=='USD'">$49</h4>
                  <h4 *ngIf="currency=='INR'">₹ 2899</h4>
                  <h5>5 Years Subscription</h5>
                </div>
              </div>
              <ul class="list-unstyled text-center">
                <li>Unlimited resume</li>
                <li>Unlimited Cover letter</li>
                <li>Font customisation</li>
                <li>Border and color option</li>
              </ul>
              <div class="">
                <button class="btn btn-block btn-default" *ngIf="currency=='USD'" (click)="startPayment(currency, '4900')">5 Years Subscription</button>
                <button class="btn btn-block btn-default" *ngIf="currency=='INR'" (click)="startPayment(currency, '289900')">5 Years Subscription</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
